import type { Session } from '@supabase/supabase-js';
import { z } from 'zod';

import { apiFetch } from '@/lib/api';

// Client-side contract for GET /api/v1/admin/password-alerts, Zod-parsed on arrival so any
// drift from the API shows as an error rather than a wrong list.
const PasswordAlertsSchema = z.object({
  data: z.array(
    z.object({
      userId: z.string(),
      occurredAt: z.string(),
      email: z.string().nullable(),
      businessName: z.string().nullable(),
    }),
  ),
});

export type PasswordAlert = z.infer<typeof PasswordAlertsSchema>['data'][number];

export const fetchPasswordAlerts = async (
  session: Session,
  signal?: AbortSignal,
): Promise<PasswordAlert[]> => {
  const { data } = await apiFetch('/api/v1/admin/password-alerts', {
    session,
    schema: PasswordAlertsSchema,
    ...(signal ? { signal } : {}),
  });
  return data;
};
